import React from 'react'
import Store from 'store'

interface Attachment {
  url: string
  name: string
  mimeType?: string
}

interface MessageProps {
  message: {
    text: string
    attachments?: Attachment[]
    affiliateUserId?: string
    agentId?: string
    sender?: string
    createdAt?: string
    date?: string
  }
  index: number
  onPreviewAttachment: (attachment: Attachment) => void
}

const getInitials = (name: string) => {
  if (!name) return ''
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
}

const Message: React.FC<MessageProps> = ({ message, index, onPreviewAttachment }) => {
  const isUser = !!message.affiliateUserId
  const senderLabel = isUser
    ? Store.get('aff-email') || 'You'
    : message.agentId
      ? 'Support agent'
      : message.sender || 'User'

  const dateLabel = message.createdAt
    ? (() => {
        const d = new Date(message.createdAt)
        const day = d.getDate().toString().padStart(2, '0')
        const month = (d.getMonth() + 1).toString().padStart(2, '0')
        const year = d.getFullYear()
        const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        return `${day}-${month}-${year} ${time}`
      })()
    : message.date || ''

  return (
    <div className={`message ${isUser ? 'message--user' : ''}`}>
      <div className={`message__avatar ${isUser ? 'message__avatar--user' : 'message__avatar--other'}`}>
        {getInitials(senderLabel)}
      </div>
      <div className={`message__content ${isUser ? 'message__content--user' : 'message__content--other'}`}>
        <p className="message__text" dangerouslySetInnerHTML={{ __html: message.text }} />
        
        {/* Display attachments if any */}
        {message.attachments && message.attachments.length > 0 && (
          <div className="message__attachments">
            {message.attachments.map((attachment, attIdx) => (
              <div key={attIdx} className="message__attachment">
                {attachment.mimeType?.startsWith('image/') ? (
                  <img
                    src={attachment.url}
                    alt={attachment.name}
                    className="message__attachment__image"
                    onClick={() => onPreviewAttachment(attachment)}
                  />
                ) : (
                  <a
                    href={attachment.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="message__attachment__link"
                  >
                    <i className="pi pi-file" />
                    {attachment.name}
                  </a>
                )}
              </div>
            ))}
          </div>
        )}
        
        <div className={`message__meta ${isUser ? 'message__meta--user' : ''}`}>
          {senderLabel} {dateLabel}
        </div>
      </div>
    </div>
  )
}

export default Message 